var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardChefs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_409_17235)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0667 53.7501L48.6 56.2835L53.6667 51.2168",
    stroke: "#0C3A2D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2671 40.1171C42.1004 40.1004 41.9004 40.1004 41.7171 40.1171C37.7504 39.9837 34.6004 36.7337 34.6004 32.7337C34.5837 28.6504 37.9004 25.3337 41.9837 25.3337C46.0671 25.3337 49.3837 28.6504 49.3837 32.7337C49.3837 36.7337 46.2171 39.9837 42.2671 40.1171Z",
    stroke: "#0C3A2D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9832 58.3499C38.9498 58.3499 35.9332 57.5832 33.6332 56.0499C29.5998 53.3499 29.5998 48.9499 33.6332 46.2666C38.2165 43.1999 45.7332 43.1999 50.3165 46.2666",
    stroke: "#0C3A2D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_17235",
    x1: 74.55,
    y1: 0.00000214197,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77C23E",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFFF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardChefs);
export default __webpack_public_path__ + "static/media/dashboard-chefs.db163e4c2470eeaafa3de4a741136f50.svg";
export { ForwardRef as ReactComponent };